module.exports = __webpack_public_path__ + "img/Project.9ca335f1.svg";